import React from "react";
import "./Sections.scss";

function QA4() {
  return (
    <section className="interview">
      <div className="interview__interview">
        <p className="interview__interview__title">
          What drew you to seek inspiration in Verona?
        </p>
        <p className="interview__interview__copy">
          Well, I like Verona and its 2000 years of incredible history. And I go
          to the Verona vineyards often to meet my close friends.{" "}
          <span className="italic">
            [Ed. Note: It’s just an hour’s drive from Roberto’s atelier in
            Vicenza.]
          </span>
        </p>
        <p className="interview__interview__copy">
          But every collection begins with a story. And it is the love story
          that drew me to Verona. It is a sad story, Romeo and Juliet.
        </p>
        <p className="interview__interview__copy">
          Let’s be quite honest about it, it is a tragedy. But it is a tragedy
          of intense emotions, which are missing today, worldwide. Real
          emotions. A story of two people who went against the world, their
          families, because they were in love. And in the end, they were
          together only when they died. So, it is an unforgettable tragedy about
          strong sentiments. For them, love is everything.
        </p>
      </div>
    </section>
  );
}

export default QA4;
